import { Axios } from '@src/app/context/Api/includes/Axios';
import { logger } from '@src/shared/includes/logger';
import { config } from '@uhg-abyss/web/tools/config';

/**
 * RiskRecordActionPathAssociation
 *
 * Associates EID's to Action Paths and vice versa.
 *
 * @param payload
 * @returns {Promise<any>}
 * @constructor
 */
export const RiskRecordActionPathAssociation = async (payload = {}) => {
  try {
    const theApiKey = payload?.[0];
    const theMutationKey = payload?.[1];
    const thePayload = payload?.[2];

    const requestArgs = {
      baseURL: config('API_URL'),
      data: thePayload,
      headers: {
        'x-api-endpoint': '/risk-records/manual/associate',
      },
      method: 'POST',
      params: { apiKey: theApiKey, mutationKey: theMutationKey },
    };

    const remoteResponse = await Axios.request(requestArgs);

    return remoteResponse.data;
  } catch (error) {
    logger.error(
      'src/entities/RiskRecord/api/requests/mutations/RiskRecordActionPathAssociation.js -> RiskRecordActionPathAssociation()',
      false,
      error
    );

    throw error;
  }
};
